import { hasBbox, hasPolygon } from 'components/ModelOutputRenderer/components/utils';
import { RegionAnnotationMap } from 'modules/Annotations/store/annotationsStore';
import { stringToColor } from 'utils/strings/strings';

export const getRegion = (annotation: CF.API.Annotations.Annotation) => (annotation.data as CF.API.BaseRegionsData).regions?.[0];

// TODO: Since we have annotations in the map, we need to add this type of hacky code for the sidebar to work
// with the canvas. Instead of having annotations, we need to use "annotation region items",
// the type of object the canvas works with.
export const getRegionId = (annotation: CF.API.Annotations.Annotation) => getRegion(annotation)?.id;

// eslint-disable-next-line consistent-return
export const getBboxRegionData = (annotation: CF.API.Annotations.Annotation) => {
  const region = getRegion(annotation);

  if (region && hasBbox(region.region_info)) {
    return {
      bbox: region.region_info.bounding_box,
      color: stringToColor(region.id),
    } as CF.API.BboxShapeProps;
  }
};

// eslint-disable-next-line consistent-return
export const getPolygonRegionData = (annotation: CF.API.Annotations.Annotation) => {
  const region = getRegion(annotation);

  if (region && hasPolygon(region.region_info)) {
    return {
      polygon: region.region_info.polygon,
      color: stringToColor(region.id),
    } as CF.API.PolygonShapeProps;
  }
};

export const getAnnotationsFromRegionMap = (regionMap: RegionAnnotationMap) => {
  return Array.from(regionMap.values()).flatMap((regionMapEntry) =>
    regionMapEntry ? Array.from(regionMapEntry.regionMap.values()).flatMap((annotations) => annotations) : [],
  );
};

export const getRegionData = (annotation: CF.API.Annotations.Annotation): CF.API.ShapeProps | undefined => {
  const bboxData = getBboxRegionData(annotation);
  if (bboxData) {
    return bboxData;
  }

  const polygonData = getPolygonRegionData(annotation);
  if (polygonData) {
    return polygonData;
  }

  return undefined;
};
